import { render, staticRenderFns } from "./spikePart1.vue?vue&type=template&id=b6543de8&scoped=true&"
import script from "./spikePart1.vue?vue&type=script&lang=ts&"
export * from "./spikePart1.vue?vue&type=script&lang=ts&"
import style0 from "./spikePart1.vue?vue&type=style&index=0&id=b6543de8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6543de8",
  null
  
)

export default component.exports